import React from 'react';

/**
 * Adds gTag script to the page.
 * Note: A npm module 'react-ga' was considered intially, but implemented
 * the following way to avoid issues with future gTag version changes.
 */
class Analytics extends React.Component {
	componentDidMount() {
		const script = document.createElement('script');

		script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-1071439709';
		script.async = true;
		document.body.appendChild(script);
		script.onload = () => this.onGtagScriptload();
	}

	onGtagScriptload() {
		window.dataLayer = window.dataLayer || [];

		this.gtag('js', new Date());
		this.gtag('config', 'AW-1071439709');
		this.gtag('config', 'DC-6342755');
	}

	// eslint-disable-next-line class-methods-use-this
	gtag() {
		// eslint-disable-next-line prefer-rest-params
		window.dataLayer.push(arguments);
	}

	render() {
		return <></>;
	}
}

export default Analytics;
